export default __webpack_public_path__ + "static/media/Spray 1.f125432b.png";